import { IGlobalState } from '../states/GlobalState';
import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { Company, CompanySearchModel } from '../models/company';

export const getCompanies = (ip: string, authData: AuthDataType, user: User, model: CompanySearchModel): Promise<Company[]> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Get Companies body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/company/search`
    console.log('Get Companies', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getCompanies ("${authData.user}") -> letti ${json.length} company`);
            console.log('getCompanies recuperato json: ' + JSON.stringify(json));
            const rv = (json as Company[]);
            console.log('getCompanies recuperate companies: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getCompanies error:', error);
            throw error;
        });
}


export const getCompany = (ip: string, authData: AuthDataType, user: User, id: number): Promise<Company> => {
        
    console.log('Get Company id: ', + id);
    const url = `${GetConfiguration().api_url}/company/${id}`
    console.log('Get Company', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getCompany ("${authData.user}") -> letti ${json.length} company`);
            console.log('getCompany recuperata json: ' + JSON.stringify(json));
            const rv = (json as Company);
            console.log('getCompany recuperata company: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getCompanies error:', error);
            throw error;
        });
}

export const updateCompany = (ip: string, authData: AuthDataType, user: User, model: Company): Promise<Company> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Update Company con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/company`
    console.log('Update Company', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`updateCompany ("${authData.user}") -> letti ${json.length} company`);
            console.log('updateCompany recuperata json: ' + JSON.stringify(json));
            const rv = (json as Company);
            console.log('updateCompany recuperata company: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('updateCompanies error:', error);
            throw error;
        });
}

export const deleteCompany = (ip: string, authData: AuthDataType, user: User, id: number): Promise<boolean> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    // console.log('Update Company con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/company`
    console.log('Delete Company', url);
    return window.fetch(url, {
        method: 'DELETE',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(id)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            // console.log(`deleteCompany ("${authData.user}") -> letti ${json.length} company`);
            console.log('deleteCompany avente id: ' + id);
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('deleteCompanies error:', error);
            throw error;
        });
}